import { apiRequest } from "../util/apiUtils";

export const checkStatus = async (payload) => {
  try {
    const res = await apiRequest(
      payload?.id ? "put" : "post",
      `application-form/guest-application-status`,
      {
        body: payload,
      }
    );

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const changeStatus = async (payload) => {
  try {
    const res = await apiRequest("patch", `application/status`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const sendReminder = async (payload) => {
  try {
    const res = await apiRequest(
      "post",
      `application/push-reminder-mail-user`,
      {
        body: payload,
      }
    );

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const statusList = async (params) => {
  try {
    const res = await apiRequest("get", `application-form/status-list`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};
